import { render } from "./DigiConfView.vue?vue&type=template&id=2a9f3d49"
import script from "./DigiConfView.vue?vue&type=script&lang=js"
export * from "./DigiConfView.vue?vue&type=script&lang=js"
script.render = render

export default script